module.exports = __webpack_public_path__ + "static/media/CBSE2019.24436915.jpg";